import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import hmsLogoWhite from '../../assets/images/IMT_logo.png';
import './Footer.css';
import axiosInstance from '../../utils/axiosConfig';

// Version constant - Update here when releasing new version
const APP_VERSION = '1.0.0';
const APP_ENVIRONMENT = 'Production';

const Footer = () => {
  const [isSuperuser, setIsSuperuser] = useState(false);

  // Fetch superuser status for conditional admin link
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await axiosInstance.get('/api/profile/me/');
        setIsSuperuser(response.data.is_superuser || false);
      } catch (error) {
        console.error('Error fetching user details for footer:', error);
      }
    };

    fetchUserDetails();
  }, []);

  return (
    <footer className="hms-footer">
      <div className="footer-container">
        {/* Left Section: Logo */}
        <div className="footer-section footer-logo-section">
          <img src={hmsLogoWhite} alt="IMT" className="footer-logo" />
        </div>

        {/* Navigation Links */}
        <div className="footer-section footer-nav-section">
          {/* Operations Column */}
          <div className="footer-nav-column">
            <h4 className="footer-nav-title">Operations</h4>
            <ul className="footer-nav-list">
              <li><Link to="/dashboard/trades">Trade Operations</Link></li>
              <li><Link to="/invoicing/dashboard">Financials</Link></li>
              <li><Link to="/dashboard/crm">CRM</Link></li>
              <li><Link to="/dashboard/risk-analytics">Product Module</Link></li>
              <li><Link to="/dashboard/legal">Legal</Link></li>
            </ul>
          </div>

          {/* TEMPORARILY DISABLED - October 17, 2025
              Reason: HAMSTIR feature temporarily hidden from users, to be reinstated later
              Backend functionality remains fully intact */}
          {/* Intelligence Column */}
          {/* <div className="footer-nav-column">
            <h4 className="footer-nav-title">Intelligence</h4>
            <ul className="footer-nav-list">
              <li><Link to="/hmstr-ai">HAMSTIR AI</Link></li>
            </ul>
          </div> */}

          {/* Resources Column */}
          <div className="footer-nav-column">
            <h4 className="footer-nav-title">Resources</h4>
            <ul className="footer-nav-list">
              <li><Link to="/knowledge-hub">Knowledge Hub</Link></li>
              <li><Link to="/training">Hamster Training</Link></li>
            </ul>
          </div>

          {/* Settings Column */}
          <div className="footer-nav-column">
            <h4 className="footer-nav-title">Hamster HR</h4>
            <ul className="footer-nav-list">
              <li><Link to="/settings/account-information">Account Info</Link></li>
              <li><Link to="/settings/my-files">My Files</Link></li>
              <li><Link to="/settings/leave-management">Leave Management</Link></li>
              <li><Link to="/settings/hms-colleagues">IMT Colleagues</Link></li>
              <li><Link to="/settings/password-security">Password Security</Link></li>
              <li><Link to="/settings/notifications">Notifications</Link></li>
              <li><Link to="/settings/todos">ToDo List</Link></li>
              {isSuperuser && (
                <li><Link to="/settings/hms-admin">Admin Dashboard</Link></li>
              )}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar: Copyright & Legal */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="footer-copyright">© 2025 IMT. All rights reserved.</p>
          <div className="footer-legal-links">
            <a href="#privacy" onClick={(e) => { e.preventDefault(); alert('Privacy Policy coming soon!'); }}>Privacy Policy</a>
            <span className="footer-separator">•</span>
            <a href="#terms" onClick={(e) => { e.preventDefault(); alert('Terms of Service coming soon!'); }}>Terms of Service</a>
            <span className="footer-separator">•</span>
            <a href="#security" onClick={(e) => { e.preventDefault(); alert('Security Policy coming soon!'); }}>Security</a>
          </div>
          <p className="footer-version">v{APP_VERSION} | {APP_ENVIRONMENT}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

